import React, { Component } from 'react';
import BaseLayout from './../../templates/base';
import ProfileForm from '../../elements/profile/form';
import Loading from "../../elements/loading";

class Profile extends Component {
	render() {
		return this.props.profile.isFetching ?
			<Loading message="Cargando..." /> :
			<ProfileForm profileSave={this.props.profileSave} loadFormData={this.props.loadFormData} {...this.props.profile} />
	}

	componentWillMount() {
		this.props.fetchProfile();
	}
}

export default BaseLayout(Profile, {
	title: `Mi perfil`,
	subnav: {
		icon: 'fa-address-card',
		name: 'Mi Perfil',
		actions: [
			{
				type: null,
				url: null,
				name: '',
				element: null
			}
		]
	}
});


// WEBPACK FOOTER //
// ./src/layouts/profile/index.jsx